import React from "react";
import { SearchCheckIcon, HeadsetIcon, ShieldCheckIcon } from "lucide-react";
import { commitments, images } from "../../data/home";
const icons = [SearchCheckIcon, HeadsetIcon, ShieldCheckIcon];
export function Commitments() {
  return <section id="engagements" className="scroll-mt-24 px-5 py-20 md:px-8 md:py-32" data-id="element-56" data-mp="1rdx5a4ai8ous">
      <div className="mx-auto max-w-7xl" data-id="element-57" data-mp="1mgwwhlm9t7zz">
        <div className="max-w-3xl" data-id="element-58" data-mp="yq10ecas7qmx">
          <p className="text-[15px] font-medium text-muted" data-id="element-59" data-mp="yr2nxg8zi5lj">Nos engagements</p>
          <h2 className="mt-3 text-4xl font-semibold leading-[1.05] tracking-tightest md:text-6xl" data-id="element-60" data-mp="uozaim2r8qxm">
            Un cabinet indépendant, aligné sur vos intérêts.
          </h2>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-12 lg:gap-10" data-id="element-61" data-mp="13pdxdpvdae38">
          <article className="relative flex min-h-[460px] flex-col justify-end overflow-hidden rounded-[28px] bg-ink lg:col-span-6" data-id="element-62" data-mp="13n15ajvwancg">
            <img src={images.meeting} alt="" className="absolute inset-0 h-full w-full object-cover opacity-55" data-id="element-63" data-mp="b0q4b84dmkf4" />
            <div className="absolute inset-0 bg-ink/40" aria-hidden="true" data-id="element-64" data-mp="7yj6fapbv7jy" />
            <div className="relative p-8 md:p-10" data-id="element-65" data-mp="cy5lzqsmozvx">
              <h3 className="max-w-md text-3xl font-semibold leading-tight tracking-tight text-canvas md:text-4xl" data-id="element-66" data-mp="hqozknrbfv0q">
                Une transparence totale sur notre rémunération
              </h3>
              <p className="mt-4 max-w-md text-[17px] leading-relaxed text-canvas/80" data-id="element-67" data-mp="3l7f8pbi72o6n">
                Chaque frais, chaque rétrocession est détaillé avant votre décision. Vous savez
                exactement ce que vous payez, et pourquoi.
              </p>
            </div>
          </article>

          <ul className="flex flex-col lg:col-span-6" data-id="element-68" data-mp="31aonb83d5j8">
            {commitments.map((item, i) => {
            const Icon = icons[i];
            return <li key={item.title} className="flex gap-6 border-b border-line py-8 first:pt-2 last:border-b-0 lg:first:pt-0" data-id="element-69" data-mp="1aeufmx7fcvu8" data-mpi={i}>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-surface" data-id="element-70" data-mp="3bfsd95vu864j">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-71" data-mp="36hzbqq5hc0al" />
                  </span>
                  <div data-id="element-72" data-mp="3khi7skl0nl6j">
                    <h3 className="text-xl font-semibold tracking-tight md:text-2xl" data-id="element-73" data-mp="3kfnt3o0c8paw">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-[17px] leading-relaxed text-muted" data-id="element-74" data-mp="2rue72rsyht0k">{item.text}</p>
                  </div>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}